export class Periodo {
  dtInicial: Date;
  dtFinal: Date;

  public static createInstance(dados: {}): Periodo {
    const item: Periodo = new Periodo();
    Object.assign(item, dados);
    return item;
  }
}
